<script setup>
import {notificationCounter} from '~/utils/notification-counter.mjs';
import tokens from '~/design-system/design-tokens.json';
const props=defineProps({count:{type:[Number,String],default:0},inline:Boolean});
const counter=computed(()=>notificationCounter(props.count,tokens.components.notificationCounter.max));
</script>
<template><span v-if="counter.visible" class="uo-notification-count" :class="{'uo-notification-count-inline':inline}" aria-hidden="true">{{counter.text}}</span></template>
